export default __webpack_public_path__ + "static/currentmodel-c6c881a8035bf60679d014150b1bc7e6.png";